import BrowserUtils from '../utils/BrowserUtils';
import moment from 'moment';
import AppStore from '../stores/AppStore';

class SessionParser {
  getMalwarePacket(data, signature) {
    const reqData = {
      rapport_api: {
        data: btoa(JSON.stringify(data)),
        signature,
      },
      analytics_api: {
        analytics_session_id: AppStore.getUserTrackingID(),
        session_start_time: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        user_agent: BrowserUtils.getUserAgent(),
        remote_address: BrowserUtils.getClientIp(),
      },
      context: 'LOGIN',
    };
    return reqData;
  }
}

export default new SessionParser();
